<template>
  <MoleculeLogout/>
</template>

<script>
export default {
  name: 'OrganismLogout',

  components: {
    MoleculeLogout: () => import('@/components/molecules/MoleculeLogout')
  }
}
</script>
